export class PositionDetails {
	public static readonly SECURITY_DETAILS_API_TYPE = {
		SECURITY_DETAILS: 'SECURITY_DETAILS',
		SECURITY_DETAILS_TAX: 'SECURITY_DETAILS_TAX',
		SECURITY_DETAILS_BLK_IDEAS: 'SECURITY_DETAILS_BLK_IDEAS',
		ASSET_CLASSES: 'ASSET_CLASSES'
	};

	public static readonly SECURITY_DETAILS_STORE_MAPPING = {
		SECURITY_DETAILS: 'positionDetails',
		SECURITY_DETAILS_TAX: 'taxDetails',
		SECURITY_DETAILS_BLK_IDEAS: 'ideaDetails',
		ASSET_CLASSES: 'positionDetails'
	};
}
